export default __webpack_public_path__ + "0c37ac987a269d4c0afa199ce799c26e.jpg";